<div class="preview-dialog" [style.minHeight]="height + 'px'" [style.minWidth]="width + 'px'">
    <div class="preview-dialog-header">
        <div class="action">
            <button class="color-primary" nz-button nzType="text" (click)="zoomIn()">
                <span nz-icon nzType="zoom-in" nzTheme="outline"></span>
            </button>
            <button class="color-primary" nz-button nzType="text">
                <span nz-icon nzType="border-outer" nzTheme="outline" (click)="originSize()"></span>
            </button>
            <button class="color-primary" nz-button nzType="text" (click)="zoomOut()">
                <span nz-icon nzType="zoom-out" nzTheme="outline"></span>
            </button>
        </div>
    </div>

    <div class="preview-dialog-body" [ngSwitch]="currentFileType">
        <img class="preview" *ngSwitchCase="FileType.IMAGE" [src]="environment.fileHost + record.fileId + withToken"
            alt="" style="">

        <pdf-viewer *ngSwitchCase="FileType.PDF" [src]="environment.fileHost + record.fileId + withToken"
            [c-maps-url]="'/assets/cmaps/'" [render-text]="true" [zoom-scale]="'page-fit'" [original-size]="false"
            style="width: 100%; height: 100%" [zoom]="pdfZoom" [(page)]="pdfPages"
            (pages-initialized)="onPageLoad($event)">
        </pdf-viewer>

        <p *ngSwitchDefault>
            暂时无法预览这个格式的文件
        </p>

    </div>
</div>
<div class="dialog">
    <div class="dialog-header">【上传文件】补充信息</div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="110 + 'px'">
                    <span class="color-danger">*</span> 文件题名
                </div>
                <div class="column" [style.width]="480 + 'px'">
                    <input type="text" placeholder="输入文件题名" [(ngModel)]="record.fileTitle">
                </div>
            </div>
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="110 + 'px'">
                    <span class="color-danger">*</span> 文件归属
                </div>
                <div class="column" [style.width]="480 + 'px'">
                    <nz-cascader [nzOptions]="orgTreeNode" [(ngModel)]="orgCascaderValue" [nzShowSearch]="true">
                    </nz-cascader>
                </div>
            </div>
            <div class="row">
                <div class="column background-page text-right" [style.width]="110 + 'px'">
                    表单代号
                </div>
                <div class="column" [style.width]="480 + 'px'">
                    <input type="text" placeholder="输入表单代号" [(ngModel)]="record.formCode">
                </div>
            </div>
            <div class="row">
                <div class="column background-page text-right" [style.width]="110 + 'px'">
                    表单编号
                </div>
                <div class="column" [style.width]="480 + 'px'">
                    <input type="text" placeholder="输入表单编号" [(ngModel)]="record.formSn">
                </div>
            </div>
            <div class="row">
                <div class="column background-page text-right" [style.width]="110 + 'px'">
                    表单名称
                </div>
                <div class="column" [style.width]="480 + 'px'">
                    <input type="text" placeholder="输入表单名称" [(ngModel)]="record.formName">
                </div>
            </div>
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="110 + 'px'">
                    <span class="color-danger">*</span> 提交日期
                </div>
                <div class="column" [style.width]="480 + 'px'">
                    <nz-date-picker [(ngModel)]="record.submitDateDate" [nzSuffixIcon]="''"
                        nzPlaceHolder="选择文件填写完成的日期（提交签字流程的日期）" nzFormat="yyyy-MM-dd">
                    </nz-date-picker>
                </div>
            </div>
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="110 + 'px'">
                    <span class="color-danger">*</span> 完成日期
                </div>
                <div class="column" [style.width]="480 + 'px'">
                    <nz-date-picker [(ngModel)]="record.finishDateDate" [nzSuffixIcon]="''"
                        nzPlaceHolder="文件完成所有签字和盖章的日期" nzFormat="yyyy-MM-dd">
                    </nz-date-picker>
                </div>
            </div>
            <div class="row">
                <div class="column background-page text-right" [style.width]="110 + 'px'">
                    文件摘要
                </div>
                <div class="column" [style.width]="480 + 'px'">
                    <input type="text" placeholder="输入文件摘要信息" [(ngModel)]="record.remark">
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>